import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { AdditionalNavItem, Drawer, DrawerItem } from '@sitebase/web-shell-kit';
import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import { FEATURE_TYPE, LANGUAGE_ITEM_CLICKED, LANGUAGE_MENU_SHOW, LANGUAGE_MENU_HIDE } from '../constants';
import { renderFlag } from './renderFlag';

const makeOnClick = (data) => () => {
  publish({ topic: LANGUAGE_ITEM_CLICKED, data });
};

const renderDropdownContent = (items, currentLocale) => (
  <Drawer>
    {items.map((language) => (
      <DrawerItem
        id={`${FEATURE_TYPE}-${language.code}`}
        key={`${FEATURE_TYPE}-${language.code}`}
        active={currentLocale === language.code}
        onClick={makeOnClick(language)}
        icon={renderFlag(language.code)}
      >
        {language.label}
      </DrawerItem>
    ))}
  </Drawer>
);

export const LanguageMenuRenderer = ({ data, currentLocale }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ids = [
      subscribe(LANGUAGE_MENU_SHOW, () => {
        setVisible(true);
      }),
      subscribe(LANGUAGE_MENU_HIDE, () => {
        setVisible(false);
      }),
    ];
    return () => {
      if (ids && ids.length) {
        ids.forEach((subscribeId) => unsubscribe(subscribeId));
      }
    };
  }, []);

  const currentLanguage = data.items.find((language) => language.code === currentLocale) || {};
  const itemSharedProps = {
    'data-test-id': `${FEATURE_TYPE}_${data.id}`,
    id: data.id,
    icon: process.env.RUNTIME === 'browser' ? renderFlag(currentLanguage.code) : undefined,
  };

  if (!visible) {
    return null;
  }

  if (data.isNested) {
    return (
      <DrawerItem {...itemSharedProps}>
        {currentLanguage.label || data.label}
        {renderDropdownContent(data.items, currentLanguage.code)}
      </DrawerItem>
    );
  }

  return (
    <AdditionalNavItem {...itemSharedProps} label={currentLanguage.label || data.label}>
      {renderDropdownContent(data.items, currentLanguage.code)}
    </AdditionalNavItem>
  );
};

LanguageMenuRenderer.propTypes = {
  currentLocale: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isNested: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
      })
    ),
  }),
};
